import { render, staticRenderFns } from "./aftersaleOrderVo.vue?vue&type=template&id=69b0b76a&scoped=true&"
import script from "./aftersaleOrderVo.vue?vue&type=script&lang=js&"
export * from "./aftersaleOrderVo.vue?vue&type=script&lang=js&"
import style0 from "./aftersaleOrderVo.vue?vue&type=style&index=0&id=69b0b76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b0b76a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b0b76a')) {
      api.createRecord('69b0b76a', component.options)
    } else {
      api.reload('69b0b76a', component.options)
    }
    module.hot.accept("./aftersaleOrderVo.vue?vue&type=template&id=69b0b76a&scoped=true&", function () {
      api.rerender('69b0b76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/after-sale/detail/components/aftersaleOrderVo.vue"
export default component.exports